var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('config-card', { ref: "form", attrs: { "title": _vm.title, "form-config": _vm.formConfig, "form-value": _vm.formValue, "form-item-list": _vm.formItemList, "channel-id": _vm.channelId } });
};
var staticRenderFns = [];

export { render, staticRenderFns };